import React from 'react';
import { useSelector } from 'react-redux';
import { DialogContainer, Flex, ProgressCircle, useDialogContainer, View, } from '@adobe/react-spectrum';
import { Text } from 'app/views/components/typography/Text';
import { noop } from 'app/utils/function';
const BusyDialogContent = (props) => {
    const { id, message, memo } = props;
    const dialog = useDialogContainer();
    const lastId = React.useRef(id);
    React.useCallback(() => {
        if (lastId.current && lastId.current !== id) {
            dialog.dismiss();
        }
    }, [dialog, id]);
    lastId.current = id;
    const hasMessage = message && message.length;
    const hasMemo = memo && memo.length;
    const hasMessageAndMemo = hasMessage && hasMemo;
    const marginBottom = !hasMessageAndMemo ? 'size-350' : 'size-500';
    return (React.createElement(View, { padding: "size-200" },
        React.createElement(Flex, { direction: "column", marginTop: "size-500", marginBottom: marginBottom, justifyContent: "center", alignItems: "center" },
            React.createElement(ProgressCircle, { marginBottom: "size-100", "aria-label": "Loading\u2026", isIndeterminate: true }),
            hasMessage && (React.createElement(Text, { size: hasMessageAndMemo ? 'S' : 'XS' }, message)),
            hasMessageAndMemo && React.createElement(Text, { size: "XS" }, memo))));
};
export const BusyDialog = () => {
    const busy = useSelector((state) => state.editor.busy);
    if (!busy) {
        return null;
    }
    return (React.createElement(DialogContainer, { isDismissable: false, isKeyboardDismissDisabled: false, onDismiss: noop },
        React.createElement(BusyDialogContent, { id: busy.id, message: busy.message, memo: busy.memo })));
};
